import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NoteService } from '@univacity/angular/datas';
import { File, Note, Program, RESOURCE } from '@univacity/shared/types';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { DestroyAbleComponent } from '../destroyable/destroyable.component';

interface IModal {
  note: Note;
  program: Pick<Program, 'name'>;
}

@Component({
  selector: 'un-create-note',
  templateUrl: './create-note.component.html',
  styleUrls: ['./create-note.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CreateNoteComponent
  extends DestroyAbleComponent
  implements OnInit
{
  note: Note;
  program: Pick<Program, 'name'>;
  private readonly nzModalData: IModal = inject(NZ_MODAL_DATA);

  form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private modal: NzModalRef,
    private noteService: NoteService,
    private message: NzMessageService
  ) {
    super();
  }

  async ngOnInit() {
    this.note = this.nzModalData.note;
    this.program = this.nzModalData.program;

    this.form = this.fb.group({
      remark: [null, Validators.required],
      attachments: [[]],
    });
    this.cdr.detectChanges();
  }

  submit() {
    const { remark, attachments } = this.form.value;
    const payload = {
      resourceType: RESOURCE.note,
      type: this.note.type,
      reference: this.note.reference,
      remark,
      attachments: attachments.map((v: File) => v.src),
    };

    this.noteService.create(payload).subscribe({
      next: (note) => {
        this.message.success($localize`Note added`);
        this.modal.close({ note });
      },
      error: (err) => this.message.error($localize`${err.message}`),
    });
  }
}
